export default "__VITE_ASSET__DaiJAKHi__"